import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { CustomerTable } from './CustomerTable';
import { CreateCustomer } from './CreateCustomer';
import { UpdateCustomer } from './UpdateCustomer';
import { ReinviteCustomerUser } from './ReinviteCustomerUser';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';
import { AccessLevel, AdminFeature, UserContext } from '../../../../Context/UserContext/UserContext';

export const Customers = () => {
  const { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);
  const { hasAccessToFeature } = useContext(UserContext);

  useEffect(() => {
    setHeader(formatMessage({ id: 'admin.customers.header', defaultMessage: 'Customers' }));
  }, [setHeader, formatMessage]);

  return (
    <Routes>
      <Route path="/" element={<CustomerTable />} />
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="create" element={<CreateCustomer />} />
      )}
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path=":id" element={<UpdateCustomer />} />
      )}
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="reinvite" element={<ReinviteCustomerUser />} />
      )}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
